// Subset of ReportSoldTicketColumnName from ReportingService

export enum SoldTicketReportTableGroupingColumnId {
  EventDateLocal = 'LocalEventDateTime',
  EventName = 'EventName',
  VenueName = 'VenueName',
  CityName = 'CityName',
  StateProvince = 'StateProvince',
  CountryName = 'CountryName',
  PerformerName = 'PerformerName',
  TopLevelCategoryName = 'TopLevelCategoryName',
  ParentCategoryName = 'parentCategoryName',
  EventId = 'EventId',
  Section = 'Section',
  SeatingRow = 'SeatingRow',
  Seat = 'Seat',
  ListingId = 'ListingId',
  SaleId = 'SaleId',
  SaleDate = 'SaleDate',
  SaleDay = 'SaleDay',
  SaleWeek = 'SaleWeek',
  SaleMonth = 'SaleMonth',
  SaleStatusName = 'SaleStatusName',
  PaymentReferenceId = 'PaymentReferenceId',
  TicketTypeId = 'TicketTypeId',
  InHandDate = 'InHandDate',
  LastPaymentDate = 'LastPaymentDate',
  SaleCancellationDate = 'SaleCancellationDate',
  FulfillerSellerUserId = 'FulfillerSellerUserId',
  FulfillmentDate = 'FulfillmentDate',
  SaleInternalNotes = 'SaleInternalNotes',
  SaleMarketplacePaymentStateName = 'SaleMarketplacePaymentStateName',
  MarketplaceSaleId = 'MarketplaceSaleId',
  MarketplaceName = 'MarketplaceName',
  IsSeatSaver = 'IsSeatSaver',
  IsNoFulfill = 'IsNoFulfill',
  PurchaseOrderId = 'PurchaseOrderId',
  VendorOrderId = 'VendorOrderId',
  PurchaseInsertedBy = 'PurchaseInsertedBy',
  PurchaseOrderDate = 'PurchaseOrderDate',
  BuyerUserId = 'BuyerUserId',
  PurchaseOrderVendorName = 'PurchaseOrderVendorName',
  EncryptedEmailAddress = 'EncryptedEmailAddress',
  PurchaseOrderCancellationDate = 'PurchaseOrderCancellationDate',
  PurchasePaymentStatusName = 'PurchasePaymentStatusName',
  PurchasePaymentMethodTypeName = 'PurchasePaymentMethodTypeName',
  PurchaseOrderInternalNotes = 'PurchaseOrderInternalNotes',
  SaleSeatFrom = 'SaleSeatFrom',
  SaleSeatTo = 'SaleSeatTo',
}

export enum SoldTicketReportTableValueColumnId {
  UnitNetProceeds = 'UnitNetProceeds',
  Charges = 'Charges',
  Credits = 'Credits',
  OutstandingBalance = 'OutstandingBalance',
  PandL = 'PandL',
  Margin = 'Margin',
  UnitCost = 'UnitCost',
  UnitCostFeesIncluded = 'UnitCostFeesIncluded',
  Quantity = 'Quantity',
}

export const SOLD_TICKET_REPORT_TABLE_FORMULA_COLUMNS: SoldTicketReportTableValueColumnId[] =
  Object.values(SoldTicketReportTableValueColumnId);
